import { useState } from 'react';
import { Typography } from 'seagull';
import { WideArrowDownward, WideArrowUpward } from 'seagull/icons';
import { utils } from "../../../../../../utils";
import { currencyUtils } from "../../../../../../utils/currency.utils";
import { formatShortMonthUSDate } from "../../../../../../utils/date-formatting";
import { BillingStageType } from "../../../../../../models/manual-service-billing";
import styles from "./RemainingStages.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function RemainingStages(props) {
  const {
    billingStages,
    service
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const title = isOpen ? 'Hide remaining stages' : 'View remaining stages';
  const handleClick = () => {
    setIsOpen(!isOpen);
  };
  const filteredBillingStages = billingStages.filter(stage => stage.type !== BillingStageType.Billed);
  const stagesDescription = filteredBillingStages.map(stage => {
    switch (stage.type) {
      case BillingStageType.Available:
        return "".concat(currencyUtils.formatDollarAmount(utils.applyDiscount(stage.amount, service.cost.discount)), " to be billed manually");
      case BillingStageType.Scheduled:
        return "".concat(currencyUtils.formatDollarAmount(utils.applyDiscount(stage.amount, service.cost.discount)), " scheduled to bill on ").concat(formatShortMonthUSDate(new Date(stage.scheduled.year, stage.scheduled.month - 1, stage.scheduled.day)));
    }
  }).filter(description => description !== '');
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs("div", {
      "data-testid": "remaining-stages",
      className: styles.container,
      onClick: handleClick,
      children: [/*#__PURE__*/_jsx(Typography, {
        skin: "link",
        children: title
      }), isOpen ? /*#__PURE__*/_jsx(WideArrowUpward, {
        fill: "#6942F8",
        width: 16,
        height: 16
      }) : /*#__PURE__*/_jsx(WideArrowDownward, {
        fill: "#6942F8",
        width: 16,
        height: 16
      })]
    }), isOpen && /*#__PURE__*/_jsx("div", {
      className: styles.stages,
      children: stagesDescription.map((description, index) => /*#__PURE__*/_jsx(Typography, {
        skin: "secondary",
        variant: "paragraph2",
        "data-testid": "remaining-stage-".concat(index),
        children: description
      }, index))
    })]
  });
}